import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import './css/index.css';
import HttpService from "./services/HttpService";
import UserService from "./services/UserService";

const appRenderer =()=> ReactDOM.render(
  <App/>,
document.getElementById('root')
);

UserService.initKeycloak(appRenderer);
HttpService.configure();